import React from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { Challenges } from '../../../editor/types/Experiments';
import LegacyWidget from './Widget';
import V3Widget from '../v3/Widget';

const Widget = (props: React.ComponentProps<typeof LegacyWidget>) => {
  const { experiments } = useExperiments();

  return experiments.enabled(Challenges.participantPageV3)
    ? React.createElement(V3Widget)
    : React.createElement(LegacyWidget, props);
};

export default Widget;
